import instance from 'shared/helpers/axios';
import { catchError } from '../../helpers/catchError';

const fetchUser = async () => {
  try {
    const response = await instance.get(`/auth/ping`);

    return response.data;
  } catch (error) {
    catchError(error);
  }
};

export default fetchUser;
